/** @format */
import { IconVariant } from '@mpb-com/feather/components/atoms/icon/types';

import { ProductTrustCardVariant } from './types';

export const getIconVariant = (variant?: ProductTrustCardVariant) => {
    switch (variant) {
        case ProductTrustCardVariant.SUN:
            return IconVariant.CORE;
        case ProductTrustCardVariant.WHITE:
        default:
            return IconVariant.DECORATIVE;
    }
};
